import React from 'react';
import { StethoscopeIcon, DumbbellIcon, LayersIcon, TrendingUpIcon, ClipboardCheckIcon, FileTextIcon, PrinterIcon, FolderOpenIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: StethoscopeIcon,
  color: 'text-teal-700'
}, {
  Icon: DumbbellIcon,
  color: 'text-amber-600'
}, {
  Icon: LayersIcon,
  color: 'text-blue-950'
}, {
  Icon: TrendingUpIcon,
  color: 'text-green-600'
}, {
  Icon: ClipboardCheckIcon,
  color: 'text-teal-700'
}, {
  Icon: FileTextIcon,
  color: 'text-amber-600'
}, {
  Icon: PrinterIcon,
  color: 'text-blue-950'
}, {
  Icon: FolderOpenIcon,
  color: 'text-green-600'
}];
export function BenefitsGrid() {
  return <section className="bg-slate-100 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-7" data-mp="505xd6xcaz5a">
      <h2 className="mx-auto max-w-[620px] text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[26px]" data-id="element-8" data-mp="jk4xhihiwh">
        This is not another knee rehabilitation manual filled with basic theory.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] text-[13px] font-bold uppercase leading-tight text-teal-700 md:text-[16px]" data-id="element-9" data-mp="26qejkf67ouot">
        It is an organized collection of practical, specialized resources for physical therapists treating patients after
        knee surgery.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-10" data-mp="21rth093hlyx7">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i % icons.length];
        const isLastOdd = i === benefits.length - 1 && benefits.length % 2 === 1;
        return <article key={b.title} className={`flex gap-2.5 rounded-md border border-slate-200 bg-white p-3 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-11" data-mp="2uexnyjm54nbm" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-12" data-mp="2kh19bhtzva8r" />
              <div data-id="element-13" data-mp="1546mwhtvysmx">
                <h3 className="text-[14px] font-bold leading-tight text-blue-950 md:text-[15px]" data-id="element-14" data-mp="193fiztcef2ln">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-slate-600 md:text-[14px]" data-id="element-15" data-mp="3bqvyoewhgjia">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
      <p className="mt-3.5 text-[13px] font-extrabold uppercase leading-tight text-amber-700 md:text-[15px]" data-id="element-16" data-mp="320jggtc552fb">
        One collection. Seven surgical categories. Five professional bonuses.
      </p>
    </section>;
}